__turbopack_context__.v({
  "clear": "XVnedW_clear",
  "controls": "XVnedW_controls",
  "filterRow": "XVnedW_filterRow",
  "noMatches": "XVnedW_noMatches",
  "noMatchesText": "XVnedW_noMatchesText",
  "select": "XVnedW_select",
});
